import { useEffect } from 'react';
import store from '../../containers/App/store';

const useTabCounter = () => {
  const isLoggedIn = store.getState()?.auth?.isLoggedIn;
  const currentCustomerID = store.getState()?.customer?.currentCustomer?.customerID;
  // console.log('isLoggedIn', isLoggedIn);
  useEffect(() => {
    if (!isLoggedIn) return;

    const isNewTab = !sessionStorage.getItem('tabInitialized');
    const currentTabCount = parseInt(localStorage.getItem('tabsOpen')) || 0;

    if (isNewTab) {
      sessionStorage.setItem('tabInitialized', 'true');
      localStorage.setItem('tabsOpen', currentTabCount + 1);
    }

    const handleStorageChange = (e) => {
      // Only respond to changes in 'tabsOpen' key
      if (e.key === 'tabsOpen') {
        const newCount = parseInt(e.newValue);
        if (!isNaN(newCount)) {
          console.log('Tab count updated:', newCount);
        }
      }
    };

    const handleUnload = () => {
      const currentCount = parseInt(localStorage.getItem('tabsOpen'));
      if (!isNaN(currentCount) && currentCount > 0) {
        const updatedTabCount = currentCount - 1;
        localStorage.setItem('tabsOpen', updatedTabCount);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [isLoggedIn]);
};

export default useTabCounter;
